import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { LuUserRound } from "react-icons/lu";
import StepLayout from "../components/StepLayout";
import { ParentEditor } from "../components/FormControls";

export default function FatherStep({ parents, setParents, formatPhone, complete, error, busy, onBack, onSave }) {
  return <StepLayout step={4} headerIcon={<LuUserRound/>} iconBg="teal.50" iconColor="teal.600" title="Datos de papá" description="Se usará como segundo contacto familiar." back={onBack} next={onSave} disabled={!complete} busy={busy}>
    <Box maxW="520px">
      <ParentEditor active="padre" parents={parents} setParents={setParents} formatPhone={formatPhone}/>
      {error && <Text mt="4" color="red.600" fontSize="sm">{error}</Text>}
    </Box>
  </StepLayout>;
}
